module.exports = __webpack_public_path__ + "static/media/galleryGT (18).d1fba09f.jpg";